import { isParaServiceType } from 'src/logic/serviceType';
import { routes } from 'src/routes';

type NewStudentAssignedData = { studentId: string; serviceType?: string };

/** Paras have no Goals tab, so their "new placement" notification opens the schedule instead. */
export const getNewStudentAssignedTarget = (data: NewStudentAssignedData) => {
  const studentRoot = routes.singleStudent.root.replace(':id', data.studentId);
  return isParaServiceType(data.serviceType)
    ? { label: 'View Schedule', path: `${studentRoot}/${routes.singleStudent.schedule}` }
    : { label: 'Review Goals', path: `${studentRoot}/${routes.singleStudent.goals}` };
};
